<!-- Main Content -->
<div class="dashboard-container">
  <!-- Stats Grid -->
  <div class="stats-grid">
    <!-- Clients Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/group_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Clients">
      </div>
      <div class="stats-info">
        <h4>{{ clientCount }}</h4>
        <p>Clients</p>
      </div>
    </div>

    <!-- Total Loans Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/description_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Prêts">
      </div>
      <div class="stats-info">
        <h4>{{ initialLoanSize }}</h4>
        <p>Prêts</p>
      </div>
    </div>

    <!-- Paid Loans Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/done_all_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Payé">
      </div>
      <div class="stats-info">
        <h4>MAD {{ paymentDetails.paid | number:'1.2-2' }}</h4>
        <p>Prêts Payés</p>
      </div>
    </div>

    <!-- Unpaid Loans Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/error_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Non Payé">
      </div>
      <div class="stats-info">
        <h4>MAD {{ paymentDetails.unpaid | number:'1.2-2' }}</h4>
        <p>Prêts Non Payés</p>
      </div>
    </div>
  </div>

  <!-- Controls Bar -->
  <div class="controls-bar">
    <button (click)="openClientFormDialog()" class="create-button">
      <img src="../../assets/add_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg" alt="Créer">
      <span>Créer un Prêt</span>
    </button>

    <div class="filters">
      <div class="search-box">
        <input type="search" (input)="onInputChange($event)" placeholder="Rechercher un Prêt">
      </div>
      <input type="date" (change)="onDateChange($event)" class="date-picker">
      <select (change)="onStatusChange($event)" class="status-select">
        <option value="">État du Prêt</option>
        <option value="true">Payé</option>
        <option value="false">Non Payé</option>
      </select>
    </div>
  </div>

  <!-- Table Section -->
  <div class="orders-container">
    <!-- Desktop View -->
    <table class="orders-table desktop-view">
      <thead>
        <tr>
          <th>Client</th>
          <th>Téléphone</th>
          <th>Montant</th>
          <th>État</th>
          <th>Date du Prêt</th>
          <th class="text-end">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isTableLoading">
          <td colspan="6" class="text-center py-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>
        <tr *ngFor="let loan of loansToDisplay" [class.d-none]="isTableLoading">
          <td>
            <div class="client-info">
              <div class="client-avatar">
                {{ ((loan.client?.firstName || '').charAt(0) || '') + ((loan.client?.lastName || '').charAt(0) || '') | uppercase }}
              </div>
              <div class="client-name">
                {{loan.client?.firstName}} {{loan.client?.lastName}}
              </div>
            </div>
          </td>
          <td>{{loan.client?.phoneNumber}}</td>
          <td>MAD {{loan.amount}}</td>
          <td>
            <span [class]="'status-badge ' + (loan.isPaid ? 'paid' : 'unpaid')">
              {{loan.isPaid ? 'Payé' : 'Non Payé'}}
            </span>
          </td>
          <td>{{loan.loanDate | date: 'dd MMMM, yyyy'}}</td>
          <td>
            <div class="action-buttons">
              <button (click)="goToLoanDetails(loan)" class="action-btn view-btn">
                <i class="fa fa-eye"></i>
              </button>
              <button (click)="goToLoanEdit(loan)" class="action-btn edit-btn">
                <i class="fa fa-pencil"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile View -->
    <div class="mobile-view">
      <div *ngIf="isTableLoading" class="text-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="order-card" *ngFor="let loan of loansToDisplay" [class.d-none]="isTableLoading">
        <div class="order-card-header">
          <div class="client-info">
            <div class="client-avatar">
              {{ ((loan.client?.firstName || '').charAt(0) || '') + ((loan.client?.lastName || '').charAt(0) || '') | uppercase }}
            </div>
            <div class="client-details">
              <h3>{{loan.client?.firstName}} {{loan.client?.lastName}}</h3>
              <p>{{loan.client?.phoneNumber}}</p>
            </div>
          </div>
          <span [class]="'status-badge ' + (loan.isPaid ? 'paid' : 'unpaid')">
            {{loan.isPaid ? 'Payé' : 'Non Payé'}}
          </span>
        </div>
        <div class="order-card-body">
          <div class="order-info">
            <div class="info-item">
              <span class="label">Montant:</span>
              <span class="value">MAD {{loan.amount}}</span>
            </div>
            <div class="info-item">
              <span class="label">Date:</span>
              <span class="value">{{loan.loanDate | date: 'dd MMMM, yyyy'}}</span>
            </div>
          </div>
          <div class="order-actions">
            <button (click)="goToLoanDetails(loan)" class="action-btn view-btn">
              <i class="fa fa-eye"></i> Voir
            </button>
            <button (click)="goToLoanEdit(loan)" class="action-btn edit-btn">
              <i class="fa fa-pencil"></i> Modifier
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <app-paginator
      [totalItems]="loanSize"
      [itemsPerPage]="loansPerPage"
      [currentPage]="currentPage"
      [pages]="pages"
      [pagedItemsSize]="loansToDisplay.length"
      (pageChange)="onPageChange($event)">
    </app-paginator>
  </div>
</div>
